import { getAreaData, getDict, getNation, getTreeDict, postSalary } from "api/api"
import { keysConstant } from "./constant/key"

const { T_DIC_PROTECH, T_DIC_PROQUALITY, T_DIC_NATION, T_DIC_POLITICS, T_DIC_EDUCATION, T_DIC_AAC033, T_PSM_DOMICILE,
  T_DIC_UNEMPREASON, T_DIC_FWORKTYPE, T_DIC_PROLEVEL, T_DIC_WORKENVIRONMENT, T_DIC_WORKNATURE,
  T_DIC_PROFESSION, T_DIC_LANGUAGE, T_DIC_LANGUAGESKILL, T_DIC_COMPUTERSKILL, T_DIC_WAGELEVEL,
  T_PSM_EMPLOYTYPE, T_DIC_FLEXITYPE, T_DIC_LICENSETYPE, T_DIC_EMPHARD, T_DIC_INDUSTRY, T_DIC_UNITTYPE,
  T_DIC_ECONOMIC, T_DIC_PERSON, T_DIC_PROTECNLEVEL, T_PSM_SALARYPACKAGE, NATION } = keysConstant

/** 
 * 这里中文提出常量辉导致data那边的数据都要改动,开发者不好直观的看到数据名称,所以不提出常量 
 */
export const getKey = (label) => {
  switch (label) {
    case '民族':
      return T_DIC_NATION
    case '政治面貌':
      return T_DIC_POLITICS
    case '学历':
      return T_DIC_EDUCATION // 原本失业登记 的学历用这个数据字典，两个返回的数据一样，我统一用这个了
    case '健康状况':
      return T_DIC_AAC033
    case '户口性质':
      return T_PSM_DOMICILE
    case '失业原因':
      return T_DIC_UNEMPREASON
    case '原工种':
      return T_DIC_FWORKTYPE
    case '职业(工种)资格':
    case '意向岗位':
      return T_DIC_PROQUALITY
    case '国家职业资格等级':
    case '职业资格等级':
      return T_DIC_PROLEVEL
    // return T_DIC_PROQUALITY
    case '工作环境':
      return T_DIC_WORKENVIRONMENT
    case '工作性质':
      return T_DIC_WORKNATURE
    case '所学专业':
      return T_DIC_PROFESSION
    case '职称':
    case '专业技术职务':
      return T_DIC_PROTECH
    case '专业技术等级':
      return T_DIC_PROTECNLEVEL
    case '外语语种':
      return T_DIC_LANGUAGE
    case '外语水平':
      return T_DIC_LANGUAGESKILL
    case '计算机水平':
      return T_DIC_COMPUTERSKILL
    case '试用期月工资档次':
      return T_DIC_WAGELEVEL
    case '就业类型':
      return T_PSM_EMPLOYTYPE
    case '灵活就业方式':
      return T_DIC_FLEXITYPE
    case '驾照类型':
      return T_DIC_LICENSETYPE
    case '人员类别':
      return T_DIC_EMPHARD
    case '所属行业':
      return T_DIC_INDUSTRY
    case '单位类型':
      return T_DIC_UNITTYPE
    case '经济类型':
      return T_DIC_ECONOMIC
    case '人员规模':
      return T_DIC_PERSON
    case '期望薪资':
      return T_PSM_SALARYPACKAGE
      case '补贴对象类型':
        return T_DIC_EMPHARD
    // case '学历':
    // return T_DIC_ACADEMIC // 原本我要招人 的学历用这个数据字典
    case '常住地址':
    case '户籍地址':
    case '工作地点行政区划':
    case '所属地区行政区划代码':
      return NATION
    default:
      return ''
  }
}

export const getApi = (key) => {
  switch (key) {
    case T_DIC_NATION:  // 民族
      return getNation
    case T_DIC_POLITICS:  //政治面貌
    case T_DIC_EDUCATION: // 学历
    case T_DIC_AAC033: // 健康状况
    case T_PSM_DOMICILE: // 户口性质
    case T_DIC_UNEMPREASON: // 失业原因
    case T_DIC_FWORKTYPE: // 原工种
    case T_DIC_PROLEVEL: // 国家职业资格等级、等级
    case T_DIC_WORKENVIRONMENT: // 工作环境
    case T_DIC_WORKNATURE: // 工作性质
    case T_DIC_PROFESSION: // 所学专业
    case T_DIC_LANGUAGE: // 外语语种
    case T_DIC_LANGUAGESKILL: // 外语水平
    case T_DIC_COMPUTERSKILL: // 计算机水平
    case T_DIC_WAGELEVEL: // 试用期月工资档次
    case T_PSM_EMPLOYTYPE: // 就业类型
    case T_DIC_FLEXITYPE: // 灵活就业方式
    case T_DIC_LICENSETYPE: // 驾照类型
    case T_DIC_EMPHARD: // 人员类别 和补贴对象类型
    case T_DIC_INDUSTRY: // 所属行业
    case T_DIC_UNITTYPE: // 单位类型
    case T_DIC_ECONOMIC: // 经济类型
    case T_DIC_PERSON: // 人员规模
    case T_DIC_PROTECNLEVEL: // 专业技术等级
      // case T_DIC_ACADEMIC: // 学历
      return getDict
    case T_DIC_PROQUALITY: // 职业(工种)资格、意向岗位
    case T_DIC_PROTECH: // 职称
      return getTreeDict
    case T_PSM_SALARYPACKAGE: // 期望薪资
      return postSalary
    case NATION:  // 常住地址、户籍地址、工作地点行政区划、所属地区行政区划代码
      return getAreaData
    default:
      return ''
  }
}